import { render, staticRenderFns } from "./WideLayout.vue?vue&type=template&id=2d9b476c&scoped=true&"
import script from "./WideLayout.vue?vue&type=script&lang=ts&"
export * from "./WideLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WideLayout.vue?vue&type=style&index=0&id=2d9b476c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b476c",
  null
  
)

export default component.exports